import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NzButtonModule, NzButtonType } from 'ng-zorro-antd/button';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzPopoverModule } from 'ng-zorro-antd/popover';

@Component({
  selector: 'app-popover-edit-text',
  standalone: true,
  imports: [CommonModule, FormsModule, NzPopoverModule, NzInputModule, NzButtonModule, MatTooltipModule],
  templateUrl: './popover-edit-text.component.html',
  styleUrl: './popover-edit-text.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopoverEditTextComponent {
  @Input() buttonType: NzButtonType = 'primary';
  @Input() content?: string;
  @Input() editTitle = 'Edit';
  @Output() saveChange = new EventEmitter<string>();

  isVisible = false;

  onContentChange(text: string) {
    this.content = text;
  }

  onSaveClick() {
    this.isVisible = false;
    this.saveChange.emit(this.content);
  }
}
